import { render, staticRenderFns } from "./queryBillPayment.vue?vue&type=template&id=20e2a2d6&scoped=true&"
import script from "./queryBillPayment.vue?vue&type=script&lang=js&"
export * from "./queryBillPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2a2d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e2a2d6')) {
      api.createRecord('20e2a2d6', component.options)
    } else {
      api.reload('20e2a2d6', component.options)
    }
    module.hot.accept("./queryBillPayment.vue?vue&type=template&id=20e2a2d6&scoped=true&", function () {
      api.rerender('20e2a2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/query/queryBillPayment.vue"
export default component.exports